import { render } from "./FilmPosterComponent.vue?vue&type=template&id=1bbc0f40&scoped=true"
import script from "./FilmPosterComponent.vue?vue&type=script&lang=js"
export * from "./FilmPosterComponent.vue?vue&type=script&lang=js"

import "./FilmPosterComponent.vue?vue&type=style&index=0&id=1bbc0f40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bbc0f40"]])

export default __exports__